<div class="modal-body edit-notes">
  <div class="content">
    <div class="content__top">
      <h4 translate>company.integrations.edit.title</h4>
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <i class="icon-small-close"></i>
      </button>
    </div>
    <div class="content__form">
      <form [formGroup]="form" *ngIf="!loading && form">
        <div class="form-group">
          <label for="name" translate>company.user.form.first-name.label</label>
          <div class="vox-input-group vox-input-group_dense" [ngClass]="{
              'vox-input-group_invalid': isFieldValid('name')
            }">
            <input class="vox-text-field" type="text" id="name" formControlName="name"
              [placeholder]="'company.user.form.first-name.placeholder' | translate" /><i
              class="vox-text-field__icon vox-text-field__icon_black icon-small-alert"></i><span
              class="vox-input-group__error-message" translate>company.user.form.first-name.required</span>
          </div>
        </div>
        <div class="form-group" formGroupName="custom_fields" *ngIf="integration.custom_fields.length > 0 && (!isEmptyCF && !setupDataError)">
          <h5 *ngIf="!hideTitle" translate>company.integrations.edit.form.fields</h5>
          <div *ngFor="let c of customFieldsFormGroup?.controls | keyvalue: controlSort" class="form-group">
            <div class="vox-input-group vox-input-group_dense"
              *ngIf="!DEFAULT_FIELD_TYPES.includes(c.key)"
              [ngClass]="{ 'vox-input-group_invalid': customFieldsFormGroup?.controls[c.key].invalid && customFieldsFormGroup?.controls[c.key].touched }">
              <label>{{'company.integrations.edit.form.'+ c.key.toLowerCase()  | translate: { name:integration.name } }}</label>
              <input [type]="c.value.field_type" class="vox-text-field" [formControlName]="c.key"/>
              <i class="vox-text-field__icon icon-small-alert"></i>
              <span *ngIf="customFieldsFormGroup?.controls[c.key].errors?.required"
                class="vox-input-group__error-message" translate>errors.required</span>
            </div>

            <div *ngIf="c.key === 'DEFAULT_USER_ID'">
              <label>{{'company.integrations.edit.form.'+ c.key.toLowerCase()  | translate: { name:integration.name } }}</label>
              <gdp-integration-select-user [users]="setupData?.users" [formControlName]="c.key">
              </gdp-integration-select-user>
            </div>

            <div class="form-group" *ngIf="['CHANNEL_ID', 'WORK_TYPE_ID', 'DEPARTMENT_ID', 'LIST_ID'].includes(c.key) && setupData && setupData[CUSTOM_FIELDS_NAME[c.key]]?.length > 0">
              <div class="vox-input-group mb-3">
                <label>{{'company.integrations.edit.form.'+ c.key.toLowerCase()  | translate: { name: integration.name } }}</label>
                <div ngbDropdown class="vox-dropdown-input">
                  <button id="module" ngbDropdownToggle>
                    <span>{{ form.get('custom_fields.' + c.key).value.name }}</span>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="module">
                    <button ngbDropdownItem *ngFor="let data of setupData[CUSTOM_FIELDS_NAME[c.key]]"
                      (click)="selectValue(c.key, data)">{{data.name}}</button>
                  </div>
                </div>
              </div>
            </div>

            <div *ngIf="c.key === 'TEAM_ID'">
              <gdp-integration-select-team
                [loading]="false" 
                [formControlName]="c.key" 
                [setupDataTeam]="setupData?.teams"
              ></gdp-integration-select-team>
              <!-- [setupDataTeam]="setupData?.teams" -->
            </div>

            <div *ngIf="c.key === 'AUTOMATIC_CONTACT_CREATION'">
              <div class="checkbox-container">
                <input [id]="c.key" class="vox-checkbox" [formControlName]="c.key" type="checkbox" container="body"
                  [ngbTooltip]="'company.integrations.edit.form.'+ c.key.toLowerCase() + '-tooltip' | translate: {name: integration.name}">
                  <label [for]="c.key">{{ 'company.integrations.edit.form.'+ c.key.toLowerCase() | translate:{name: integration.name} }}</label>
              </div>
            </div> 
            <div *ngIf="c.key === 'USER_MAPPING'">
              <gdp-integration-user-mapping [connection]="integration" [allAvailableUsers]="allAvailableUsers" [formControlName]="c.key"></gdp-integration-user-mapping>
            </div>
          </div>
        </div>
        <h5 translate *ngIf="isEmptyCF || setupDataError">company.integrations.edit.form.fields</h5>
        <div class="vox-inline-message vox-inline-message_light-grey" *ngIf="isEmptyCF && !setupDataError">
          <div>
            <i class="icon-small-info"></i>
            <span
              [innerHTML]="'company.integrations.notifications.error.empty-cf' | translate"></span>
          </div>
        </div>
        <div class="vox-inline-message vox-inline-message_light-grey" *ngIf="setupDataError">
          <div>
            <i class="icon-small-alert"></i>
            <span
              [innerHTML]="'company.integrations.notifications.error.api-error' | translate"></span>
          </div>
        </div>
        <div class="submit-container">
          <button class="vox-btn vox-btn-primary" [ladda]="isSaving" (click)="save()" type="submit" [disabled]="form.invalid"
            data-spinner-color="grey" data-style="zoom-in">
            <span translate>company.integrations.edit.form.save</span>
          </button>
        </div>
      </form>
      <div *ngIf="loading">
        <div>
          <div *ngFor="let c of [1, 2, 3]">
            <ngx-skeleton-loader [theme]="{'height':'40px', 'margin-bottom':'6px', 'margin-top':'0px'}">
            </ngx-skeleton-loader>
          </div>
        </div>
        <div>
          <ngx-skeleton-loader
            [theme]="{'height':'30px', 'width': '150px', 'margin-bottom':'6px', 'margin-top':'20px'}">
          </ngx-skeleton-loader>
          <div *ngFor="let c of [1, 2, 3]">
            <ngx-skeleton-loader [theme]="{'height':'40px', 'margin-bottom':'6px', 'margin-top':'0px'}">
            </ngx-skeleton-loader>
          </div>
        </div>
        <div class="btn__loader">
          <ngx-skeleton-loader [theme]="{'height':'50px', 'width': '100px', 'margin-bottom':'6px', 'margin-top':'0px'}">
          </ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</div>